import BodyText from 'components/Luxkit/Typography/BodyText'
import React, { useContext } from 'react'
import Group from 'components/utils/Group'
import { TrustIndicatorUK } from 'home/components/UspBanner/TrustIndicatorUK'
import { TrustPilotLogoSmall, FacebookLogo } from './common'
import GeoContext from 'contexts/geoContext'

export function TrustIndicatorsMapper() {
  const { currentRegionCode } = useContext(GeoContext)
  const isUK = currentRegionCode === 'GB'

  return (
    <Group direction="horizontal" verticalAlign="center" gap={24} horizontalAlign={!isUK ? 'start' : 'center'}>
      {!isUK && (
        <>
          <Group gap={8} direction="horizontal" verticalAlign="start">
            <TrustPilotLogoSmall />
            <BodyText weight="bold" variant="large" wrap="no-wrap">Trustpilot · 4.8/5</BodyText>
          </Group>
          <Group gap={8} direction="horizontal" verticalAlign="center">
            <FacebookLogo />
            <BodyText weight="bold" variant="large" align="center" wrap="no-wrap">1,484,233 followers</BodyText>
          </Group>
        </>
      )}
      {isUK && (
        <TrustIndicatorUK />
      )}
    </Group>
  )
}
